var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard_8425094 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8354 2.29453H16.1204C15.976 1.00594 14.8806 0 13.554 0H10.4462C9.11963 0 8.02416 1.00594 7.87932 2.29453H5.15072C3.73463 2.29453 2.58057 3.44859 2.58057 4.86797V21.4266C2.58057 22.8459 3.73463 24 5.15072 24H18.8495C20.2656 24 21.4196 22.8459 21.4196 21.4266V4.87875C21.4196 3.45234 20.2618 2.29453 18.8354 2.29453ZM19.697 21.4266C19.697 21.8953 19.3182 22.2773 18.8495 22.2773H5.15072C4.68197 22.2773 4.30322 21.8948 4.30322 21.4266V4.86844C4.30322 4.39969 4.68197 4.01766 5.15072 4.01766H8.72354C9.19885 4.01766 9.58463 3.63187 9.58463 3.15656V2.58469C9.58463 2.10938 9.97041 1.72359 10.4457 1.72359H13.5535C14.0288 1.72359 14.4146 2.10938 14.4146 2.58469V3.15656C14.4146 3.63187 14.8004 4.01766 15.2757 4.01766H18.8349C19.3103 4.01766 19.696 4.40344 19.696 4.87875V21.4266H19.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3483 7.20422H10.7393C10.264 7.20422 9.87817 7.59 9.87817 8.06532C9.87817 8.54063 10.264 8.92641 10.7393 8.92641H16.3483C16.8236 8.92641 17.2094 8.54063 17.2094 8.06532C17.2094 7.59 16.8236 7.20422 16.3483 7.20422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.91718 7.10062H7.65187C7.17655 7.10062 6.79077 7.4864 6.79077 7.96171V8.16843C6.79077 8.64374 7.17655 9.02952 7.65187 9.02952H7.91718C8.39249 9.02952 8.77827 8.64374 8.77827 8.16843V7.96171C8.77874 7.48687 8.39296 7.10062 7.91718 7.10062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3483 13.9809H10.7393C10.264 13.9809 9.87817 14.3667 9.87817 14.842C9.87817 15.3173 10.264 15.7031 10.7393 15.7031H16.3483C16.8236 15.7031 17.2094 15.3173 17.2094 14.842C17.2094 14.3667 16.8236 13.9809 16.3483 13.9809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.91718 13.8741H7.65187C7.17655 13.8741 6.79077 14.2598 6.79077 14.7351V14.9419C6.79077 15.4172 7.17655 15.803 7.65187 15.803H7.91718C8.39249 15.803 8.77827 15.4172 8.77827 14.9419V14.7351C8.77874 14.2603 8.39296 13.8741 7.91718 13.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.3483 10.5909H10.7393C10.264 10.5909 9.87817 10.9767 9.87817 11.452C9.87817 11.9273 10.264 12.3131 10.7393 12.3131H16.3483C16.8236 12.3131 17.2094 11.9273 17.2094 11.452C17.2094 10.9767 16.8236 10.5909 16.3483 10.5909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.91718 10.4873H7.65187C7.17655 10.4873 6.79077 10.8731 6.79077 11.3484V11.5551C6.79077 12.0305 7.17655 12.4162 7.65187 12.4162H7.91718C8.39249 12.4162 8.77827 12.0305 8.77827 11.5551V11.3484C8.77874 10.8736 8.39296 10.4873 7.91718 10.4873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.3483 17.3676H10.7393C10.264 17.3676 9.87817 17.7534 9.87817 18.2287C9.87817 18.7041 10.264 19.0898 10.7393 19.0898H16.3483C16.8236 19.0898 17.2094 18.7041 17.2094 18.2287C17.2094 17.7534 16.8236 17.3676 16.3483 17.3676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.91718 17.2645H7.65187C7.17655 17.2645 6.79077 17.6503 6.79077 18.1256V18.3323C6.79077 18.8077 7.17655 19.1934 7.65187 19.1934H7.91718C8.39249 19.1934 8.77827 18.8077 8.77827 18.3323V18.1256C8.77874 17.6503 8.39296 17.2645 7.91718 17.2645Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.b780a58ff1097ea9ce34579b261762af.svg";
export { ForwardRef as ReactComponent };